// extracted by mini-css-extract-plugin
export default {"note":"chatNote_note__1zR2K","loader":"chatNote_loader__RfOX+","l1":"chatNote_l1__JaFuW"};